import type { RemoveJobSeekerProfileStructuredDataInput } from "../../../../../../../../__generated__/types.gqlgenerated";

import YellowLightCategoryType from "../../../types/YellowLightCategoryType";
export const getRequirementIds = (
  categoryType: YellowLightCategoryType,
  ids: string[],
): RemoveJobSeekerProfileStructuredDataInput => {
  switch (categoryType) {
    case YellowLightCategoryType.CERTIFICATIONS:
      return { certificationIds: ids };
    case YellowLightCategoryType.EDUCATION:
      return { educationIds: ids };
    case YellowLightCategoryType.LANGUAGES:
      return { languageIds: ids };
    case YellowLightCategoryType.LICENSE:
      return { licenseIds: ids };
    case YellowLightCategoryType.OCCUPATION:
      return { occupationIds: ids };
    case YellowLightCategoryType.SKILLS:
      return { skillIds: ids };
    case YellowLightCategoryType.WORK_EXPERIENCE:
      return { workExperienceIds: ids };
    default:
      throw new Error("Requirement type does not exist");
  }
};
